import types from '@/common/configs/types'
import filters from '@/common/configs/filters'



/*
    Returns number or undefined
*/

const toNumber = (value, defaults, min = 0, max = Number.MAX_VALUE) => {
    value = +value;
    return isNaN(value) || value < min || value > max ? defaults : value;
};



/*
    Validates params
*/

export function validateParams (params, defaults = {}) {

    let {done, type, buildingType, minBuiltAt, maxBuiltAt, minPrice, maxPrice, minSqm, maxSqm, minDealtAt, maxDealtAt, sort: [sort, order] = [], lat, lng, zoom, heatmap, search} = params;

    minBuiltAt = toNumber(minBuiltAt);
    maxBuiltAt = toNumber(maxBuiltAt);
    minPrice = toNumber(minPrice);
    maxPrice = toNumber(maxPrice);
    minSqm = toNumber(minSqm);
    maxSqm = toNumber(maxSqm);
    minDealtAt = toNumber(minDealtAt);
    maxDealtAt = toNumber(maxDealtAt);
    zoom = toNumber(zoom, defaults.zoom);
    lat = toNumber(lat, defaults.lat, -90, 90);
    lng = toNumber(lng, defaults.lng, 0, 180);

    type = type || defaults.type;
    if (Object.values(types).every(({value}) => value !== buildingType)) {
        buildingType = undefined;
    }

    if (filters.sort.indexOf(sort) === -1 ||
        !['asc', 'desc'].includes(order)) {
        sort = undefined, order = undefined;
    }
    if (minBuiltAt && maxBuiltAt && maxBuiltAt < minBuiltAt) maxBuiltAt = undefined;
    if (minPrice && maxPrice && maxPrice < minPrice) maxPrice = undefined;
    if (minSqm && maxSqm && maxSqm < minSqm) maxSqm = undefined;
    if (minDealtAt && maxDealtAt && maxDealtAt < minDealtAt) maxDealtAt = undefined;

    return {done, type, buildingType, minBuiltAt, maxBuiltAt, minPrice, maxPrice, minSqm, maxSqm, minDealtAt, maxDealtAt, lat, lng, zoom, sort: [sort, order], heatmap, search};
}



/*
    Converts params to API params
*/

export function parseParams (params) {

    const {done, type, buildingType, minBuiltAt, maxBuiltAt, minPrice, maxPrice, minSqm, maxSqm, minDealtAt, maxDealtAt, sort: [sort, order = 'asc'] = [], zoom, bounds, search} = params;
    let parsed = {done, type, buildingType, minSqm, maxSqm, zoom, search};

    if (sort) parsed[`sort[${sort}]`] = order;
    if (minBuiltAt) parsed.minBuiltAt = new Date(minBuiltAt, 0, 1).getTime();
    if (maxBuiltAt) parsed.maxBuiltAt = new Date(maxBuiltAt, 11, 31).getTime();
    if (minDealtAt) parsed.minDealtAt = new Date(minDealtAt, 0, 1).getTime();
    if (maxDealtAt) parsed.maxDealtAt = new Date(maxDealtAt, 11, 31).getTime();
    if (minPrice) parsed.minPrice = minPrice * 10000;
    if (maxPrice) parsed.maxPrice = maxPrice * 10000;

    if (bounds) {
        const {south, west, north, east} = bounds;
        parsed['location[min]'] = [west, north];
        parsed['location[max]'] = [east, south];
    }

    return parsed;

}
